export default __webpack_public_path__ + "img/arrow-right.0ec1a44a.svg";